import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEMedicalElectronicsCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Medical Electronics",
    shortName: "B.E. Medical Electronics",
    duration: "4 years",
    description: "Specialized engineering program focused on electronic systems and devices for medical and healthcare applications",
    overview: "Bachelor of Engineering in Medical Electronics (B.E. Medical Electronics) is a 4-year undergraduate program that combines electronics engineering with medical technology and healthcare applications. This course covers biomedical instrumentation, medical imaging, diagnostic equipment, therapeutic devices, and healthcare IT systems, preparing students for careers in the rapidly growing medical device industry.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Interest in electronics and healthcare technology"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Biology",
          "Basic Electronics",
          "Medical Terminology"
        ]
      },
      {
        year: 2,
        subjects: [
          "Electronic Devices and Circuits",
          "Digital Electronics",
          "Human Anatomy and Physiology",
          "Biomedical Instrumentation",
          "Signals and Systems",
          "Medical Physics"
        ]
      },
      {
        year: 3,
        subjects: [
          "Medical Imaging Systems",
          "Therapeutic Equipment",
          "Biosignal Processing",
          "Medical Device Design",
          "Healthcare IT Systems",
          "Biocompatibility and Safety"
        ]
      },
      {
        year: 4,
        subjects: [
          "Advanced Medical Devices",
          "Telemedicine Systems",
          "Medical Device Regulations",
          "AI in Healthcare",
          "Project Work",
          "Hospital Internship"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Medical Device Engineer",
        "Biomedical Engineer",
        "Clinical Engineer",
        "Medical Equipment Technician",
        "Product Development Engineer",
        "Regulatory Affairs Engineer",
        "Application Engineer",
        "Field Service Engineer",
        "Quality Assurance Engineer",
        "Healthcare IT Specialist"
      ],
      industries: [
        "Medical Device Manufacturing",
        "Hospitals and Healthcare",
        "Diagnostic Equipment Companies",
        "Pharmaceutical Industry",
        "Healthcare IT",
        "Medical Research Institutions",
        "Regulatory Bodies",
        "Medical Equipment Distributors",
        "Telemedicine Companies",
        "Rehabilitation Centers"
      ],
      averageSalary: "₹4-9 LPA (Fresher), ₹12-35 LPA (Experienced)",
      topRecruiters: [
        "Siemens Healthineers, GE Healthcare",
        "Philips Healthcare, Medtronic",
        "Johnson & Johnson, Abbott",
        "BPL Medical, Mindray",
        "HCL Healthcare, Wipro Healthcare",
        "Fortis Healthcare, Apollo Hospitals"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "PSG College of Technology",
        location: "Coimbatore",
        fees: "₹4,50,000",
        ranking: "NIRF Ranking: 42"
      },
      {
        name: "SRM Institute of Science and Technology",
        location: "Chennai",
        fees: "₹12,00,000",
        ranking: "NIRF Ranking: 41"
      },
      {
        name: "VIT University",
        location: "Vellore",
        fees: "₹7,83,000",
        ranking: "NIRF Ranking: 15"
      },
      {
        name: "Manipal Institute of Technology",
        location: "Manipal",
        fees: "₹15,00,000",
        ranking: "Deemed University"
      }
    ],

    skills: [
      "Biomedical Instrumentation",
      "Medical Device Design",
      "Biosignal Processing",
      "Medical Imaging",
      "Healthcare IT Systems",
      "Regulatory Compliance",
      "Clinical Engineering",
      "Medical Device Testing",
      "Healthcare Analytics",
      "Patient Safety Systems"
    ],

    futureScope: "Excellent growth prospects with aging population, digital health transformation, AI in healthcare, telemedicine, and personalized medicine driving demand for medical electronics engineers.",

    faqs: [
      {
        question: "What career opportunities exist in Medical Electronics?",
        answer: "Opportunities include medical device development, hospital engineering, diagnostic equipment design, healthcare IT systems, and regulatory affairs in the growing medical device industry."
      },
      {
        question: "Do I need medical knowledge for this course?",
        answer: "Basic medical knowledge is taught as part of the curriculum including anatomy, physiology, and medical terminology to understand healthcare applications."
      },
      {
        question: "Can I work in hospitals with this degree?",
        answer: "Yes, as a clinical engineer or biomedical engineer, you can work in hospitals managing medical equipment, ensuring safety, and supporting clinical operations."
      },
      {
        question: "What about opportunities in medical device startups?",
        answer: "Excellent opportunities exist in medical device startups developing innovative healthcare solutions, especially with the growth of health-tech and digital health sectors."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEMedicalElectronicsCoursePage;
